import React from 'react';
import PointAddress from "../pointAddress";
import InfoSection from "../infoSection";
import TotalBlock from "../totalBlock";
import TariffSection from "../tariffSection";
import {splitContactFio} from "../functions/contactFio";

const ParcelInfoTab = ({form: parcel, errors, companyData, options}) => {
    const extractPvzCodeFromComment = (comment) => {
        const source = String(comment || '');
        const m = source.match(/(?:код\s*)?ПВЗ[:\s-]*([A-ZА-Я0-9-]+)/i) || source.match(/код[:\s-]*([A-ZА-Я0-9-]+)/i);
        return m && m[1] ? String(m[1]).toUpperCase() : '';
    };

    const values = (name) => {
        const type = (name === 'delivery') ? 'recipient' : 'sender';
        const fio = splitContactFio(parcel[`${type}Name`]);
        const pointCode = (parcel[`${name}PointCode`] || extractPvzCodeFromComment(parcel[`${name}AddressComment`]) || '').toUpperCase();
        return {
            [`${name}ContactPersonName`]: parcel[`${type}Name`],
            [`${name}ContactLastName`]: parcel[`${name}ContactLastName`] || fio.lastName,
            [`${name}ContactFirstName`]: parcel[`${name}ContactFirstName`] || fio.firstName,
            [`${name}ContactPatronymic`]: parcel[`${name}ContactPatronymic`] || fio.patronymic,
            [`${name}Company`]: parcel[`${type}CompanyName`],
            [`${name}PhoneNumber`]: parcel[`${type}ContactInfo`],
            [`${name}Additional`]: parcel[`${type}Additional`],
            [`${name}Ext1`]: parcel[`${type}Ext1`] || parcel[`${type}Additional`],
            [`${name}AdditionalPhone`]: parcel[`${type}AdditionalPhone`],
            [`${name}Ext2`]: parcel[`${type}Ext2`],
            [`${name}PointCode`]: pointCode
        }
    }

    const form = {
        ...parcel,
        ...values('delivery'),
        ...values('shipment'),
        shipmentPvzDetails: parcel.shipmentPvzDetails,
        deliveryPvzDetails: parcel.deliveryPvzDetails,
        documentWeight: (parcel.parcelType === options.parcelTypes.parcelTypeDoc) && parcel.weight,
        cargoWeight: (parcel.parcelType !== options.parcelTypes.parcelTypeDoc) && parcel.weight,
        cargoPackages: parcel.packagesCount,
        cargoVolume: parcel.volume,
    };

    return (
        <div className='parcel-info'>
            <div className='parcel-info__from-to'>
                <PointAddress
                    isFrom
                    form={form}
                    errors={errors}
                />
                <PointAddress
                    form={form}
                    errors={errors}
                />
            </div>
            <div className='parcel-info__from-to'>
                <InfoSection
                    isDoc={form.parcelType === options.parcelTypes.parcelTypeDoc}
                    errors={errors}
                    form={form}
                    companyData={companyData}
                    total={<TotalBlock
                        isCreate={false}
                        noLabel
                        form={form}
                        isDoc={form.parcelType === options.parcelTypes.parcelTypeDoc}
                        isPallets={form.parcelType === options.parcelTypes.parcelTypePallets}
                    />}
                />
                <TariffSection
                    errors={errors}
                    form={form}
                    options={options}
                    disabled
                />
            </div>
        </div>
    );
};

export default ParcelInfoTab;


// WEBPACK FOOTER //
// ./App/pages/parcels/form_v3/tabs/parcelInfoTab.jsx